<template>
    <BreezeAuthenticatedLayout
        title="Home"
        meta-description="This is a home page specific description"
    >
    <div class="relative flex flex-col justify-center bg-gray-100 dark:bg-gray-900 sm:items-center">
        <div class="max-w-screen-2xl w-full carousel-full">
            <VueAgile v-if="slider && refresh" :options="carouselSettings" class="rounded-md shadow-md overflow-hidden w-full">
                <div class="slide w-full relative group" v-for="slide in slider" :key="slide">
                    <div v-if="slide.title" class="absolute group-hover:opacity-100 font-bold text-center transition duration-300 opacity-0 top-0 left-0 right-0 bg-gray-900 bg-opacity-20 text-gray-500 p-2">
                        {{ slide.title }}
                    </div>
                    <a target="_blank" v-if="slide.href" :href="slide.href">
                        <img class="w-full h-full object-cover object-center overflow-hidden" :src="slide.link" />
                    </a>
                    <img v-else class="w-full h-full object-cover object-center overflow-hidden" :src="slide.link" />
                </div>

                <template #prevButton>
                    <SvgIcon
                        name="arrow-left"
                        class="mx-auto"
                    />
                </template>
                <template #nextButton>
                    <SvgIcon
                        name="arrow-right"
                        class="mx-auto"
                    />
                </template>
            </VueAgile>
            <div v-else class="bg-white p-5 rounded-md shadow-md text-center">
                <ApplicationLogo class="block h-20 mx-auto mb-5 w-auto text-gray-800" />
                {{__('Slider is empty')}}
            </div>
        </div>

        <div class="max-w-screen-xl w-full py-10">
            <Heading
                :label="__('Products available')"
                class="text-center uppercase"
                :description="__('Create your own engraving')"
                size="3xl"
                type="h1"
            />
            <div class="grid lg:grid-cols-3 grid-cols-2 xs gap-6 py-8">
                <ProductCard
                    v-for="product in products" :key="product"
                    :product="product"
                />
                <h1 v-if="!products.length" class="text-xl text-center col-span-full">{{__('No products available for selected country')}}</h1>
            </div>
        </div>

        <div class="max-w-screen-2xl w-full">
            <div class="grid md:grid-cols-5 col-span-1 gap-6">
                <NewsletterCard
                    class="md:col-span-3 bg-gray-900 rounded-md shadow-md p-8"
                />
                <DiscountCard
                    class="md:col-span-2 bg-white rounded-md shadow-md overflow-hidden"
                    :value="discount"
                />
            </div>
        </div>
    </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated';
    import ApplicationLogo from 'COMP/ApplicationLogo'
    import SvgIcon from 'UI/SvgIcon';
    import Heading from 'COMP/Heading';

    import ProductCard from 'CARD/Product';
    import NewsletterCard from 'CARD/Newsletter';
    import DiscountCard from 'CARD/Discount';
    import { ref } from '@vue/runtime-core';
    import { Inertia } from '@inertiajs/inertia';

    import { VueAgile } from 'vue-agile'

    export default {
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            products: Object,
            slider: Array,
            discount: [Object, Array],
        },
        components: {
            BreezeAuthenticatedLayout,
            SvgIcon,
            ProductCard,
            Heading,
            NewsletterCard,
            DiscountCard,
            ApplicationLogo,
            VueAgile,
        },
        data: () => ({
            carouselSettings: {
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 1000,
                timing: 'ease-in-out',
            },
        }),
        setup(props) {
            const refresh = ref(true);

            Inertia.on('success', (event) => { refresh.value = false })
            Inertia.on('finish', (event) => { refresh.value = true })

            return {
                refresh
            }
        }
    }
</script>
<style lang="postcss">
.carousel-full .agile__nav-button {
    @apply top-0 absolute h-full text-xl cursor-pointer border-0 bg-transparent text-white transition duration-300 w-16;
}
.carousel-full .agile__nav-button:hover{
    @apply opacity-100 bg-black bg-opacity-25;
}
.carousel-full .agile__nav-button--prev{
	@apply left-0;
}
.carousel-full .agile__list, .carousel-full .agile__track {
    @apply h-full;
}
.carousel-full .agile__nav-button--next{
	@apply right-0;
}
.carousel-full .agile__dots{
    @apply bottom-3 absolute transform left-1/2 -translate-x-1/2;
}
.carousel-full .agile__dot{
    @apply mx-3;
}
.carousel-full .agile__dot button{
    border-radius: 50%;
    font-size: 0;
    line-height: 0;

    @apply w-3 h-3 transition duration-300 p-0 m-0 block cursor-pointer border border-red-700 bg-transparent;
}
.carousel-full .agile__dot--current button,
.carousel-full .agile__dot:hover button{
	@apply bg-red-700;
}
.carousel-full .slide{
    @apply w-full object-cover lg:h-80 md:h-64 sm:h-52 h-40 block;
}
</style>
